// extracted by mini-css-extract-plugin
export default {"chips":"chips_chips__C5BAJ","p":"chips_p__kfUh1","chipsMain":"chips_chipsMain__XV5Ly"};